import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "df-details__grid" };
const _hoisted_2 = { class: "df-details__legend" };
const _hoisted_3 = { class: "df-details__row" };
const _hoisted_4 = { class: "df-details__row" };
const _hoisted_5 = { class: "df-details__row" };
const _hoisted_6 = { class: "df-details__consents" };
const _hoisted_7 = ["id"];
import { computed } from "vue";
import { useDonation } from "../context/donationContext";
import { useChrome } from "../i18n/useChrome";
import { useFieldErrors } from "../composables/useFieldErrors";
import { nextFieldId } from "../composables/fieldId";
import { countryOptions } from "../composables/countries";
import { CIVILITIES, MAX_LENGTH } from "../composables/useDonorValidation";
import StepShell from "../components/layout/StepShell.vue";
import BaseField from "../components/ui/BaseField.vue";
import BaseInput from "../components/ui/BaseInput.vue";
import BaseSelect from "../components/ui/BaseSelect.vue";
import BaseCheckbox from "../components/ui/BaseCheckbox.vue";
import SegmentedControl from "../components/ui/SegmentedControl.vue";
import BaseButton from "../components/ui/BaseButton.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'StepDetails',
    setup(__props) {
        // SYNC: see ../_SYNC.md.
        const ctx = useDonation();
        const { lang, state, setField, isOrganization, allowCompanyDonation, requirePhone, enableBirthDate, requireConsent, showNewsletterOptIn, showProjectSelector, projectOptions, consentLabel, canProceed, next, back, } = ctx;
        const { tf } = useChrome();
        const { touch, touchAll, errorFor } = useFieldErrors(ctx);
        const donorTypeOptions = computed(() => [
            { value: "Individual", label: tf("donorType.Individual") },
            { value: "Organization", label: tf("donorType.Organization") },
        ]);
        const projectSelectOptions = computed(() => projectOptions.value.map((p) => ({ value: p.projectId, label: p.label })));
        // Selectable on purpose: civility is optional, so the donor must be able to clear it.
        const civilityOptions = computed(() => [
            { value: "", label: tf("fields.civilityPlaceholder") },
            ...CIVILITIES.map((c) => ({ value: c, label: tf(`civility.${c}`) })),
        ]);
        const countrySelectOptions = computed(() => countryOptions(lang.value));
        const today = new Date().toISOString().slice(0, 10);
        const MAX_BY_FIELD = {
            firstName: MAX_LENGTH.name,
            lastName: MAX_LENGTH.name,
            addressLine1: MAX_LENGTH.addressLine,
            addressLine2: MAX_LENGTH.addressLine,
            postalCode: MAX_LENGTH.postalCode,
            city: MAX_LENGTH.city,
            orgName: MAX_LENGTH.orgName,
            siret: MAX_LENGTH.siret,
            legalForm: MAX_LENGTH.legalForm,
        };
        const consentText = computed(() => consentLabel.value || tf("consent.fallback"));
        const consentErrorId = nextFieldId("df-consent-error");
        function fieldError(field) {
            const leaf = errorFor(field);
            return leaf ? tf(`field.${leaf}`, { max: MAX_BY_FIELD[field] }) : "";
        }
        function onContinue() {
            touchAll();
            next();
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(StepShell, {
                title: _unref(tf)('details.title'),
                subtitle: _unref(tf)('details.subtitle')
            }, {
                actions: _withCtx(() => [
                    _createVNode(BaseButton, {
                        variant: "ghost",
                        onClick: _cache[30] || (_cache[30] = ($event) => (_unref(back)()))
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(tf)("actions.back")), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createVNode(BaseButton, {
                        variant: "primary",
                        block: "",
                        "aria-disabled": !_unref(canProceed),
                        onClick: _cache[31] || (_cache[31] = ($event) => (onContinue()))
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(tf)("actions.continue")), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["aria-disabled"])
                ]),
                default: _withCtx(() => [
                    (_unref(allowCompanyDonation))
                        ? (_openBlock(), _createBlock(SegmentedControl, {
                            key: 0,
                            class: "df-details__type",
                            options: donorTypeOptions.value,
                            "model-value": _unref(state).donorType,
                            label: _unref(tf)('details.donorTypeLabel'),
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = (v) => _unref(setField)('donorType', v))
                        }, null, 8 /* PROPS */, ["options", "model-value", "label"]))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(tf)("details.requiredLegend")), 1 /* TEXT */),
                        _createVNode(BaseField, {
                            label: _unref(tf)('fields.civility'),
                            error: fieldError('civility')
                        }, {
                            default: _withCtx(({ fieldId, describedBy, hasError }) => [
                                _createVNode(BaseSelect, {
                                    id: fieldId,
                                    "model-value": _unref(state).civility,
                                    options: civilityOptions.value,
                                    autocomplete: "honorific-prefix",
                                    "aria-describedby": describedBy,
                                    invalid: hasError,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = (v) => { _unref(setField)('civility', v); _unref(touch)('civility'); })
                                }, null, 8 /* PROPS */, ["id", "model-value", "options", "aria-describedby", "invalid"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label", "error"]),
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(BaseField, {
                                label: _unref(tf)('fields.firstName'),
                                required: "",
                                error: fieldError('firstName')
                            }, {
                                default: _withCtx(({ fieldId, describedBy, hasError }) => [
                                    _createVNode(BaseInput, {
                                        id: fieldId,
                                        "model-value": _unref(state).firstName,
                                        required: "",
                                        autocomplete: "given-name",
                                        "aria-describedby": describedBy,
                                        invalid: hasError,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = (v) => _unref(setField)('firstName', v)),
                                        onBlur: _cache[3] || (_cache[3] = ($event) => (_unref(touch)('firstName')))
                                    }, null, 8 /* PROPS */, ["id", "model-value", "aria-describedby", "invalid"])
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["label", "error"]),
                            _createVNode(BaseField, {
                                label: _unref(tf)('fields.lastName'),
                                required: "",
                                error: fieldError('lastName')
                            }, {
                                default: _withCtx(({ fieldId, describedBy, hasError }) => [
                                    _createVNode(BaseInput, {
                                        id: fieldId,
                                        "model-value": _unref(state).lastName,
                                        required: "",
                                        autocomplete: "family-name",
                                        "aria-describedby": describedBy,
                                        invalid: hasError,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = (v) => _unref(setField)('lastName', v)),
                                        onBlur: _cache[5] || (_cache[5] = ($event) => (_unref(touch)('lastName')))
                                    }, null, 8 /* PROPS */, ["id", "model-value", "aria-describedby", "invalid"])
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["label", "error"])
                        ]),
                        _createVNode(BaseField, {
                            label: _unref(tf)('fields.email'),
                            required: "",
                            hint: _unref(tf)('hints.email'),
                            error: fieldError('email')
                        }, {
                            default: _withCtx(({ fieldId, describedBy, hasError }) => [
                                _createVNode(BaseInput, {
                                    id: fieldId,
                                    type: "email",
                                    inputmode: "email",
                                    "model-value": _unref(state).email,
                                    required: "",
                                    autocomplete: "email",
                                    "aria-describedby": describedBy,
                                    invalid: hasError,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = (v) => _unref(setField)('email', v)),
                                    onBlur: _cache[7] || (_cache[7] = ($event) => (_unref(touch)('email')))
                                }, null, 8 /* PROPS */, ["id", "model-value", "aria-describedby", "invalid"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label", "hint", "error"]),
                        (_unref(requirePhone))
                            ? (_openBlock(), _createBlock(BaseField, {
                                key: 0,
                                label: _unref(tf)('fields.phone'),
                                required: "",
                                error: fieldError('phone')
                            }, {
                                default: _withCtx(({ fieldId, describedBy, hasError }) => [
                                    _createVNode(BaseInput, {
                                        id: fieldId,
                                        type: "tel",
                                        inputmode: "tel",
                                        "model-value": _unref(state).phone,
                                        required: "",
                                        autocomplete: "tel",
                                        "aria-describedby": describedBy,
                                        invalid: hasError,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = (v) => _unref(setField)('phone', v)),
                                        onBlur: _cache[9] || (_cache[9] = ($event) => (_unref(touch)('phone')))
                                    }, null, 8 /* PROPS */, ["id", "model-value", "aria-describedby", "invalid"])
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["label", "error"]))
                            : _createCommentVNode("v-if", true),
                        (_unref(enableBirthDate))
                            ? (_openBlock(), _createBlock(BaseField, {
                                key: 1,
                                label: _unref(tf)('fields.birthDate'),
                                error: fieldError('birthDate')
                            }, {
                                default: _withCtx(({ fieldId, describedBy, hasError }) => [
                                    _createVNode(BaseInput, {
                                        id: fieldId,
                                        type: "date",
                                        max: _unref(today),
                                        "model-value": _unref(state).birthDate,
                                        autocomplete: "bday",
                                        "aria-describedby": describedBy,
                                        invalid: hasError,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = (v) => _unref(setField)('birthDate', v)),
                                        onBlur: _cache[11] || (_cache[11] = ($event) => (_unref(touch)('birthDate')))
                                    }, null, 8 /* PROPS */, ["id", "max", "model-value", "aria-describedby", "invalid"])
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["label", "error"]))
                            : _createCommentVNode("v-if", true),
                        _createVNode(BaseField, {
                            label: _unref(tf)('fields.addressLine1'),
                            required: "",
                            error: fieldError('addressLine1')
                        }, {
                            default: _withCtx(({ fieldId, describedBy, hasError }) => [
                                _createVNode(BaseInput, {
                                    id: fieldId,
                                    "model-value": _unref(state).addressLine1,
                                    required: "",
                                    autocomplete: "address-line1",
                                    "aria-describedby": describedBy,
                                    invalid: hasError,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = (v) => _unref(setField)('addressLine1', v)),
                                    onBlur: _cache[13] || (_cache[13] = ($event) => (_unref(touch)('addressLine1')))
                                }, null, 8 /* PROPS */, ["id", "model-value", "aria-describedby", "invalid"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label", "error"]),
                        _createVNode(BaseField, {
                            label: _unref(tf)('fields.addressLine2'),
                            error: fieldError('addressLine2')
                        }, {
                            default: _withCtx(({ fieldId, describedBy, hasError }) => [
                                _createVNode(BaseInput, {
                                    id: fieldId,
                                    "model-value": _unref(state).addressLine2,
                                    autocomplete: "address-line2",
                                    "aria-describedby": describedBy,
                                    invalid: hasError,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = (v) => _unref(setField)('addressLine2', v)),
                                    onBlur: _cache[15] || (_cache[15] = ($event) => (_unref(touch)('addressLine2')))
                                }, null, 8 /* PROPS */, ["id", "model-value", "aria-describedby", "invalid"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label", "error"]),
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(BaseField, {
                                label: _unref(tf)('fields.postalCode'),
                                required: "",
                                error: fieldError('postalCode')
                            }, {
                                default: _withCtx(({ fieldId, describedBy, hasError }) => [
                                    _createVNode(BaseInput, {
                                        id: fieldId,
                                        "model-value": _unref(state).postalCode,
                                        required: "",
                                        autocomplete: "postal-code",
                                        "aria-describedby": describedBy,
                                        invalid: hasError,
                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = (v) => _unref(setField)('postalCode', v)),
                                        onBlur: _cache[17] || (_cache[17] = ($event) => (_unref(touch)('postalCode')))
                                    }, null, 8 /* PROPS */, ["id", "model-value", "aria-describedby", "invalid"])
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["label", "error"]),
                            _createVNode(BaseField, {
                                label: _unref(tf)('fields.city'),
                                required: "",
                                error: fieldError('city')
                            }, {
                                default: _withCtx(({ fieldId, describedBy, hasError }) => [
                                    _createVNode(BaseInput, {
                                        id: fieldId,
                                        "model-value": _unref(state).city,
                                        required: "",
                                        autocomplete: "address-level2",
                                        "aria-describedby": describedBy,
                                        invalid: hasError,
                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = (v) => _unref(setField)('city', v)),
                                        onBlur: _cache[19] || (_cache[19] = ($event) => (_unref(touch)('city')))
                                    }, null, 8 /* PROPS */, ["id", "model-value", "aria-describedby", "invalid"])
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["label", "error"])
                        ]),
                        _createVNode(BaseField, {
                            label: _unref(tf)('fields.country'),
                            required: "",
                            error: fieldError('country')
                        }, {
                            default: _withCtx(({ fieldId, describedBy, hasError }) => [
                                _createVNode(BaseSelect, {
                                    id: fieldId,
                                    "model-value": _unref(state).country,
                                    options: countrySelectOptions.value,
                                    placeholder: _unref(tf)('fields.countryPlaceholder'),
                                    required: "",
                                    autocomplete: "country",
                                    "aria-describedby": describedBy,
                                    invalid: hasError,
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = (v) => { _unref(setField)('country', v); _unref(touch)('country'); })
                                }, null, 8 /* PROPS */, ["id", "model-value", "options", "placeholder", "aria-describedby", "invalid"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label", "error"]),
                        (_unref(isOrganization))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createVNode(BaseField, {
                                    label: _unref(tf)('fields.orgName'),
                                    required: "",
                                    error: fieldError('orgName')
                                }, {
                                    default: _withCtx(({ fieldId, describedBy, hasError }) => [
                                        _createVNode(BaseInput, {
                                            id: fieldId,
                                            "model-value": _unref(state).orgName,
                                            required: "",
                                            autocomplete: "organization",
                                            "aria-describedby": describedBy,
                                            invalid: hasError,
                                            "onUpdate:modelValue": _cache[21] || (_cache[21] = (v) => _unref(setField)('orgName', v)),
                                            onBlur: _cache[22] || (_cache[22] = ($event) => (_unref(touch)('orgName')))
                                        }, null, 8 /* PROPS */, ["id", "model-value", "aria-describedby", "invalid"])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["label", "error"]),
                                _createElementVNode("div", _hoisted_5, [
                                    _createVNode(BaseField, {
                                        label: _unref(tf)('fields.siret'),
                                        required: "",
                                        error: fieldError('siret')
                                    }, {
                                        default: _withCtx(({ fieldId, describedBy, hasError }) => [
                                            _createVNode(BaseInput, {
                                                id: fieldId,
                                                "model-value": _unref(state).siret,
                                                required: "",
                                                "aria-describedby": describedBy,
                                                invalid: hasError,
                                                "onUpdate:modelValue": _cache[23] || (_cache[23] = (v) => _unref(setField)('siret', v)),
                                                onBlur: _cache[24] || (_cache[24] = ($event) => (_unref(touch)('siret')))
                                            }, null, 8 /* PROPS */, ["id", "model-value", "aria-describedby", "invalid"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["label", "error"]),
                                    _createVNode(BaseField, {
                                        label: _unref(tf)('fields.legalForm'),
                                        required: "",
                                        error: fieldError('legalForm')
                                    }, {
                                        default: _withCtx(({ fieldId, describedBy, hasError }) => [
                                            _createVNode(BaseInput, {
                                                id: fieldId,
                                                "model-value": _unref(state).legalForm,
                                                required: "",
                                                "aria-describedby": describedBy,
                                                invalid: hasError,
                                                "onUpdate:modelValue": _cache[25] || (_cache[25] = (v) => _unref(setField)('legalForm', v)),
                                                onBlur: _cache[26] || (_cache[26] = ($event) => (_unref(touch)('legalForm')))
                                            }, null, 8 /* PROPS */, ["id", "model-value", "aria-describedby", "invalid"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["label", "error"])
                                ])
                            ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true),
                        (_unref(showProjectSelector))
                            ? (_openBlock(), _createBlock(BaseField, {
                                key: 3,
                                label: _unref(tf)('fields.project'),
                                required: _unref(projectOptions).length > 1,
                                error: fieldError('projectId')
                            }, {
                                default: _withCtx(({ fieldId, describedBy, hasError }) => [
                                    _createVNode(BaseSelect, {
                                        id: fieldId,
                                        "model-value": _unref(state).projectId ?? '',
                                        options: projectSelectOptions.value,
                                        placeholder: _unref(tf)('fields.projectPlaceholder'),
                                        required: _unref(projectOptions).length > 1,
                                        "aria-describedby": describedBy,
                                        invalid: hasError,
                                        "onUpdate:modelValue": _cache[27] || (_cache[27] = (v) => { _unref(setField)('projectId', v); _unref(touch)('projectId'); })
                                    }, null, 8 /* PROPS */, ["id", "model-value", "options", "placeholder", "required", "aria-describedby", "invalid"])
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["label", "required", "error"]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        (_unref(requireConsent))
                            ? (_openBlock(), _createBlock(BaseCheckbox, {
                                key: 0,
                                checked: _unref(state).gdprConsentGranted,
                                required: "",
                                "aria-describedby": fieldError('consent') ? _unref(consentErrorId) : undefined,
                                invalid: !!fieldError('consent'),
                                "onUpdate:checked": _cache[28] || (_cache[28] = (v) => { _unref(setField)('gdprConsentGranted', v); _unref(touch)('consent'); })
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(consentText.value), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["checked", "aria-describedby", "invalid"]))
                            : _createCommentVNode("v-if", true),
                        (_unref(requireConsent) && fieldError('consent'))
                            ? (_openBlock(), _createElementBlock("p", {
                                key: 1,
                                id: _unref(consentErrorId),
                                class: "df-details__consent-error",
                                role: "alert"
                            }, _toDisplayString(fieldError("consent")), 9 /* TEXT, PROPS */, _hoisted_7))
                            : _createCommentVNode("v-if", true),
                        (_unref(showNewsletterOptIn))
                            ? (_openBlock(), _createBlock(BaseCheckbox, {
                                key: 2,
                                checked: _unref(state).newsletterConsentGranted,
                                "onUpdate:checked": _cache[29] || (_cache[29] = (v) => _unref(setField)('newsletterConsentGranted', v))
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(tf)("consent.newsletter")), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["checked"]))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["title", "subtitle"]));
        };
    }
});
